window.maedaaLocalizedValue = function (value) {
  const labels = {
    'الخشبي': ['Natural wood', 'الخشبي'], 'Natural wood': ['Natural wood', 'الخشبي'],
    'البني': ['Brown', 'البني'], Brown: ['Brown', 'البني'],
    'العسلي': ['Honey', 'العسلي'], Honey: ['Honey', 'العسلي'],
    'بني فاتح': ['Light brown', 'بني فاتح'], 'Light brown': ['Light brown', 'بني فاتح'],
    'شانيل': ['Chenille', 'شانيل'], Chenille: ['Chenille', 'شانيل'],
    'جاكار': ['Jacquard', 'جاكار'], Jacquard: ['Jacquard', 'جاكار'],
    'بوكليه': ['Bouclé', 'بوكليه'], 'Bouclé': ['Bouclé', 'بوكليه'],
    'كتان معالج': ['Treated linen', 'كتان معالج'], 'Treated linen': ['Treated linen', 'كتان معالج'],
    Linen: ['Linen', 'كتان'], Mab: ['Mab', 'ماب'], Velvet: ['Velvet', 'قطيفة'],
    '١٢٠ سم': ['120 cm', '١٢٠ سم'], '١٣٠ سم': ['130 cm', '١٣٠ سم'], '١٤٠ سم': ['140 cm', '١٤٠ سم'],
    '١٦٠ × ٨٥ سم': ['160 × 85 cm', '١٦٠ × ٨٥ سم'], '١٨٠ × ٩٠ سم': ['180 × 90 cm', '١٨٠ × ٩٠ سم'],
    '160 × 85 cm': ['160 × 85 cm', '١٦٠ × ٨٥ سم'], '180 × 90 cm': ['180 × 90 cm', '١٨٠ × ٩٠ سم'],
    'أوف وايت': ['Off-white', 'أوف وايت'], 'Off-white': ['Off-white', 'أوف وايت'],
    'ميلكي': ['Milky', 'ميلكي'], Milky: ['Milky', 'ميلكي'],
    'بيج': ['Beige', 'بيج'], Beige: ['Beige', 'بيج'],
    'أبيض': ['White', 'أبيض'], White: ['White', 'أبيض'],
    'رمادي': ['Gray', 'رمادي'], Gray: ['Gray', 'رمادي'],
    'أزرق': ['Blue', 'أزرق'], 'أخضر': ['Green', 'أخضر']
  };
  const isArabic = document.documentElement.lang.toLowerCase().startsWith('ar');
  return labels[value]?.[isArabic ? 1 : 0] || value;
};

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      pendingProductRequest = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        this.variantSelectors?.querySelectorAll('input, select').forEach((option) => {
          option.disabled = true;
        });
        this.variantSelectors?.setAttribute('aria-busy', 'true');

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const sourceProductInfo = html.querySelector(selector);
          const variant = this.getSelectedVariant(sourceProductInfo);
          this.variantSelectors?.resolvePendingSelectPromise(variant, this.getVariantSelects(sourceProductInfo));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        const request = {};
        this.pendingProductRequest = request;

        fetch(requestUrl)
          .then((response) => response.text())
          .then((responseText) => {
            if (this.pendingProductRequest !== request) return;
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (this.pendingProductRequest !== request) return;
            console.error(error);
            this.variantSelectors?.querySelectorAll('input, select').forEach((option) => {
              option.disabled = false;
            });
            this.variantSelectors?.removeAttribute('aria-busy');
            this.variantSelectors?.rejectPendingSelectPromise(error);
          });
      }

      parseJsonScript(parent, selector) {
        try {
          return JSON.parse(parent?.querySelector(selector)?.textContent);
        } catch {
          return null;
        }
      }

      getVariantSelects(queryRoot) {
        return queryRoot?.querySelector('variant-selects');
      }

      getSelectedVariant(productInfoNode) {
        return this.parseJsonScript(this.getVariantSelects(productInfoNode), '[data-selected-variant]');
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects && this.variantSelectors) this.variantSelectors.replaceWith(variantSelects);
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const sourceVariantSelects = this.getVariantSelects(html);
          const variant = this.getSelectedVariant(html);

          // Resolve product:select promise before updateOptionValues replaces the variant-selects DOM element
          this.variantSelectors?.resolvePendingSelectPromise(variant, sourceVariantSelects);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updateConfiguration(variant);
          this.dispatchEvent(new CustomEvent('maedaa:variant-updated'));

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            !variant.available || (html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true),
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateConfiguration(variant) {
        const configuration = this.querySelector('[data-maedaa-configuration]');
        if (!configuration) return;

        const selectedValues = Array.from(
          this.variantSelectors?.querySelectorAll('input:checked, select') ?? []
        )
          .map((input) => input.value)
          .filter((value) => value && value !== 'Default Title');
        const summary = configuration.querySelector('[data-configuration-summary]');
        if (summary) summary.textContent = selectedValues.map(window.maedaaLocalizedValue).join(' · ') || configuration.dataset.productTitle;

        const woodValue = selectedValues.find((value) =>
          ['الخشبي', 'خشبي', 'البني', 'بني', 'العسلي', 'عسلي', 'بني فاتح', 'Natural wood', 'Brown', 'Honey', 'Light brown'].includes(value)
        );
        const woodKey = { 'الخشبي': 'Natural', 'خشبي': 'Natural', 'البني': 'Brown', 'بني': 'Brown', 'العسلي': 'Honey', 'عسلي': 'Honey', 'بني فاتح': 'LightBrown',
          'Natural wood': 'Natural', Brown: 'Brown', Honey: 'Honey', 'Light brown': 'LightBrown' }[woodValue] || 'Natural';
        const table = configuration.querySelector('[data-configuration-table]');
        const chair = configuration.querySelector('[data-configuration-chair]');
        if (table && chair) {
          const tableUrl = configuration.dataset[`table${woodKey}`];
          if (tableUrl) table.src = tableUrl;
          if (configuration.dataset.chairModel === 'nubia' || configuration.dataset.chairModel === 'luxor') return;
          const fabricValue = selectedValues.find((value) =>
            ['شانيل', 'جاكار', 'بوكليه', 'كتان معالج', 'كتان', 'كتان تويت', 'قطيفة', 'خريطة', 'خريطة – Map'].includes(value)
          );
          const fabricKey = {
            'شانيل': 'Chenille', 'جاكار': 'Jacquard', 'بوكليه': 'Boucle',
            'كتان معالج': 'TreatedLinen', 'كتان': 'Linen',
            'كتان تويت': 'LinenTweed', 'قطيفة': 'Velvet', 'خريطة': 'Map', 'خريطة – Map': 'Map'
          }[fabricValue];
          const fabricImage = configuration.dataset.chairModel === 'upholstered' && woodKey === 'Brown' && fabricKey
            ? configuration.dataset[`chairFabric${fabricKey}`]
            : null;
          chair.src = fabricImage || configuration.dataset[`chair${woodKey}`];
          chair.alt = fabricImage
            ? `${configuration.dataset.productTitle} — ${window.maedaaLocalizedValue(fabricValue)} ${window.maedaaLocalizedValue('أوف وايت')}, ${window.maedaaLocalizedValue(woodValue)}`
            : configuration.dataset.chairModel === 'siwa'
              ? (document.documentElement.lang.toLowerCase().startsWith('ar') ? 'كرسي سيوه من صورة السفرة المعتمدة' : 'Siwa chair from the approved dining-set photo')
              : `${configuration.dataset.productTitle} — ${window.maedaaLocalizedValue(woodValue || 'الخشبي')}`;
          return;
        }

        const image = configuration.querySelector('[data-configuration-image]');
        const media = variant?.featured_media;
        if (image && media?.preview_image?.src) {
          image.src = media.preview_image.src;
          image.alt = media.alt || configuration.dataset.productTitle;
        }
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // Keep the five visible thumbnails in sync with the fetched variant gallery.
        const gallery = this.querySelector('media-gallery');
        const sourceThumbnails = gallery?.querySelector('[id^="Slider-Thumbnails-"]');
        const destinationThumbnails = html.querySelector('media-gallery [id^="Slider-Thumbnails-"]');
        if (sourceThumbnails && destinationThumbnails) {
          sourceThumbnails.innerHTML = destinationThumbnails.innerHTML;
          sourceThumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
            thumbnail.querySelector('button')?.addEventListener('click', () => {
              gallery.setActiveMedia(thumbnail.dataset.target, false);
            });
          });
        }

        const sourceModalMedia = this.querySelector('product-modal [role="document"]');
        const destinationModalMedia = html.querySelector('product-modal [role="document"]');
        if (sourceModalMedia && destinationModalMedia) {
          sourceModalMedia.innerHTML = destinationModalMedia.innerHTML;
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
